<template>
  <div id="app">
    <header>
      <top />
    </header>
    <transition name="fade">
      <room-overlay v-if="showRoomOverlay" />
    </transition>
    <router-view />
  </div>
</template>
<script>
import Top from '@/components/Top';
import RoomOverlay from '@/components/RoomOverlay';

export default {
    name: 'App',
    components: {
      Top,
      RoomOverlay
    },
    computed: {
      showRoomOverlay(){
        return this.$store.state.showRoomOverlay;
      },
      showInfo(){
        return this.$store.state.showInfo;
      }
    }
}
</script>
<style lang="scss">
  @import './scss/main';
  @import './scss/variables';
</style>
